"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJfZGVmYXVsdCIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9saWJyYXJ5L3NyYy9jbGllbnQvbW9kdWxlcy9GZWVkYmFjay9GZWVkYmFja1JvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7fVxyXG5cclxuZXhwb3J0IGRlZmF1bHQgcm91dGVzO1xyXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLE1BQU0sR0FBRyxDQUFDLENBQUM7QUFBQSxJQUFBQyxRQUFBLEdBQUFDLE9BQUEsY0FFRkYsTUFBTSJ9